<h2 mat-dialog-title>{{ 'profile.change_photo' | translate }}</h2>
<div mat-dialog-content class="photo-dialog-content">
  <div class="photo-preview">
    <img [src]="previewUrl || 'assets/images/default-avatar.png'" alt="preview" class="photo-preview-img" />
  </div>
  <input type="file" accept="image/jpeg,image/png,image/webp" (change)="onFileSelected($event)" />
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'common.cancel' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="!selectedFile" (click)="onSave()">{{ 'profile.save_photo' | translate }}</button>
</div>
